import { getStuList, getCourseSchedule, getMyCourse, getWeekData, getCourseMenu, getFaceCourseMenu, getLivePath, getHistoryPath, getCourseInfo, getRecordCourseMenu, checkRecordUrl, getRecordUrls, getMyCoursev2, getRecordInfo } from '@/api/study/index';

const mine = {
  actions: {
    // 获取会员账户详细信息
    getStuList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getStuList(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 课程表
    getCourseSchedule({ commit }, data) {
      return new Promise((resolve, reject) => {
        getCourseSchedule(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 我的课程
    getMyCourse({ commit }, data) {
      return new Promise((resolve, reject) => {
        getMyCourse(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 我的课程New
    getMyCoursev2({ commit }, data) {
      return new Promise((resolve, reject) => {
        getMyCoursev2(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 返回有课程的日期集合
    getWeekData({ commit }, data) {
      return new Promise((resolve, reject) => {
        getWeekData(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据班级id获取直播课目录
    getCourseMenu({ commit }, data) {
      return new Promise((resolve, reject) => {
        getCourseMenu(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据班级id获取面授课目录
    getFaceCourseMenu({ commit }, data) {
      return new Promise((resolve, reject) => {
        getFaceCourseMenu(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取直播的跳转地址信息
    getLivePath({ commit }, data) {
      return new Promise((resolve, reject) => {
        getLivePath(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 如果是直播课的历史课程/有回放的课程，点击回放，跳转的地址
    getHistoryPath({ commit }, data) {
      return new Promise((resolve, reject) => {
        getHistoryPath(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 课程详情页，获取课程信息
    getCourseInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getCourseInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 课程详情页，获取录播课程信息
    getRecordInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getRecordInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据班级id获取录播课目录
    getRecordCourseMenu({ commit }, data) {
      return new Promise((resolve, reject) => {
        getRecordCourseMenu(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据录播课课次id校验课次的有效性
    checkRecordUrl({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkRecordUrl(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 根据录播课id获取录播课视频地址
    getRecordUrls({ commit }, data) {
      return new Promise((resolve, reject) => {
        getRecordUrls(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default mine;



// WEBPACK FOOTER //
// ./src/store/study.js